export default {
  GET_USERS_MANUAL_URL: 'GET_USERS_MANUAL_URL'
}
